// export const listProviders = [
//   8, 14, 15, 16, 24, 34, 35, 36, 37, 39, 40, 42, 43, 44, 46, 48, 51, 53, 56, 60,
//   70, 74, 75, 76, 78, 79, 80, 89, 90, 93, 94, 95, 97, 99, 101, 102, 103, 108,
//   110, 120, 124, 126, 128, 132, 133, 134, 138, 140, 144, 145, 147, 150, 151,
//   153,
// ]
export const listProviders = [3, 4, 2147, 2148, 2149, 2150, 2151]
//[8, 14, 15, 16, 24, 34, 35, 36]
// HERE

/** BGaming vendor externalID, the only provider free spins bonuses can be issued for */
export const BGAMING_PROVIDER_EXTERNAL_ID = 3

/** BGaming caps the games of a single freespins issue, mirrors MAX_FREE_SPIN_GAMES in the bonus engine */
export const MAX_FREE_SPIN_GAMES = 99

/** freeSpinQuantity bounds enforced by CreateBonusDto/UpdateBonusDto in the bonus engine */
export const MIN_FREE_SPIN_QUANTITY = 1
export const MAX_FREE_SPIN_QUANTITY = 1000
